<template>
  <div>
    <gg-btn tertiary small class="mb-2" :to="backPath">
      <v-icon small left>mdi-arrow-left</v-icon>All filters
    </gg-btn>

    <!-- The form only shows while creating or editing; otherwise the list
         alone, with Create in its header (AM-1107). CreateFilter and the table
         read the address from the route. -->
    <create-filter
      v-if="form.open"
      cancelable
      :editing="form.editing"
      @stored="closeForm"
      @cancel="closeForm"
    />
    <gg-card v-else>
      <gg-card-header>
        <div class="d-flex align-center flex-wrap">
          <span class="mr-auto">Current Filters</span>
          <gg-btn secondary small class="my-1" @click="openForm(false)">
            <v-icon left small>mdi-plus</v-icon>Create Filter
          </gg-btn>
        </div>
      </gg-card-header>
      <gg-card-text>
        <filter-table @edit="openForm(true)" />
      </gg-card-text>
    </gg-card>
  </div>
</template>

<script>
import CreateFilter from '@/components/Services/Hosting/Shared/Email/GlobalFilters/CreateFilter'
import FilterTable from '@/components/Services/Hosting/Shared/Email/GlobalFilters/Table'
import { accountPath } from '@/consts/email'

// The hosting section's per-address filters, shown inside an email account.
export default {
  name: 'AccountFiltersManageView',
  components: { CreateFilter, FilterTable },
  // Passed down by EmailAccountView, which has already pointed the hosting
  // context at this account's service.
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      form: {
        open: false,
        // The table has already loaded the filter into the store.
        editing: false,
      },
    }
  },
  computed: {
    backPath () {
      return accountPath(this.$route.params.maindomain, 'filters')
    },
  },
  methods: {
    openForm (editing) {
      this.form = { open: true, editing }
    },
    closeForm () {
      this.form = { open: false, editing: false }
    },
  },
}
</script>
